import { render } from "./WrapperHeader.vue?vue&type=template&id=0a9b1427"
import script from "./WrapperHeader.vue?vue&type=script&lang=js"
export * from "./WrapperHeader.vue?vue&type=script&lang=js"

import "./WrapperHeader.vue?vue&type=style&index=0&id=0a9b1427&lang=scss"

import exportComponent from "D:\\angren\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__